import { useMutation, useQueryClient, } from "@tanstack/react-query";
import { useState } from "react";
import { genIdempotencyKey } from "../../utils/genIdempotencyKey";
import { postTask } from "../requests/postTask";
import { taskUrl } from "../requests/urls";
import { tasksKeyMakerV4 } from "./useGetTasks";
export const useCreateTask = (auth, options) => {
    const queryClient = useQueryClient();
    const idemDescriptor = "post-task";
    const [idempotencyKey, setIdempotencyKey] = useState(genIdempotencyKey(idemDescriptor));
    return useMutation(async ({ requestData, files = {} }) => await postTask(requestData, idempotencyKey, files, auth), {
        onSuccess: (data) => {
            // Invalidate all cached paginated tasks queries
            queryClient.invalidateQueries({ queryKey: tasksKeyMakerV4(null) });
            // Invalidate specific task cache
            queryClient.invalidateQueries({
                queryKey: [taskUrl("v4", data.id)],
            });
            // If this is a subtask, invalidate parent's cache
            if (data.parent?.id) {
                queryClient.invalidateQueries({
                    queryKey: [taskUrl("v4", data.parent.id)],
                });
            }
        },
        onSettled: () => {
            // NOTE: generate new idempotency key
            setIdempotencyKey(genIdempotencyKey(idemDescriptor));
        },
        ...options,
    });
};
//# sourceMappingURL=useCreateTask.js.map